import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { CompProps } from '../../Editor'
import { BtTaxIdInput } from '@linqpal/components/src/ui'
import { useEditorModel } from '../../useEditorModel'
import { View } from 'react-native'

export const TaxIDInput: React.FC<CompProps & { testID?: string }> = ({
  doc,
  group,
  item,
  review,
  onValueUpdate,
  testID,
}) => {
  const { t } = useTranslation('application')

  const validateEditorValue = useCallback(
    (value: string | null) => value?.length === 9,
    [],
  )

  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    '',
    validateEditorValue,
  )

  const handleChange = (value: string) => {
    if (/^\d*$/.test(value)) {
      model.setValue('value', value)
    }
  }

  const validate = () =>
    model.value?.length !== 9 ? t('ValidationErrors.InvalidTaxID') : ''

  return (
    <View style={{ marginTop: review ? 24 : 18 }}>
      <BtTaxIdInput
        size="large"
        label={t('Business.TaxIdLabel')}
        value={model.value}
        validate={validate}
        onChangeText={handleChange}
        testID={testID}
      />
    </View>
  )
}
